import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "cross-circle-18", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { transform: "translate(-3 -3)", fill: "none", fillRule: "evenodd" },
        React.createElement("circle", { fillOpacity: 0.15, fill: "currentColor", cx: 12, cy: 12, r: 9 }),
        React.createElement("path", { stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", d: "M9 9l6 6m0-6l-6 6" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
